import { render, staticRenderFns } from "./master-penjualan.vue?vue&type=template&id=36c9450a"
import script from "./master-penjualan.vue?vue&type=script&lang=js"
export * from "./master-penjualan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports